/** @format */

import {WidgetStat} from 'components/PropertyWidget/model';

import {FunnelGoalStatFromQuery} from '../../models/api';

interface NeedUpdateCrOptions {
  prevLabel?: string;
  prevCustom?: {
    aGoalId?: number | string;
    bGoalId?: number | string;
    crComputedHash?: string;
  };
  custom: {aGoalId?: number | string; bGoalId?: number | string};
  label: string;
  prevStats?: unknown[];
  funnelGoalStats: ReadonlyArray<FunnelGoalStatFromQuery>;
  graphComplexValuesKeysCount: number;
}

export const needUpdateCrStats = ({
  prevLabel,
  prevCustom = {},
  custom,
  label,
  prevStats,
  funnelGoalStats,
  graphComplexValuesKeysCount,
}: NeedUpdateCrOptions): boolean => {
  const idsChanged =
    String(prevCustom.aGoalId) !== String(custom.aGoalId) ||
    String(prevCustom.bGoalId) !== String(custom.bGoalId);
  const labelChanged = (prevLabel || '') !== label;
  const statsMissing = !prevStats || prevStats.length === 0;
  const statsArePlaceholder = Boolean(
    (prevStats as WidgetStat[])?.[0]?.heading === 'Выбрать показатели',
  );
  const dataHash = `${funnelGoalStats.length}|${graphComplexValuesKeysCount}`;
  const dataChanged = String(prevCustom.crComputedHash || '') !== dataHash;

  return idsChanged || labelChanged || statsMissing || statsArePlaceholder || dataChanged;
};
